<template>
    <div class="member_profile" v-if="member != null">

        <div class="member_profile_back_area display_responsive">
            <div class="back_btn_div" @click="$router.replace('/')">
                <div class="back_btn"></div>
                <div class="back_text">{{label['member_profile_page_header_text']}}</div>
                <div class="back_btn no_icon"></div>
            </div>
        </div>

        <div class="member_profile_area">
            
            <div class="member_profile_back_area display_desktop">
                <div class="back_btn_div" @click="$root.goBack()">
                    <div class="back_btn"></div>
                </div>
            </div>        
            
            <!-- member info start -->
            <div class="member_profile_area_details">
                <div class="member_profile_title no_padding_top display_desktop">{{label['member_profile_page_header_text']}}</div>
                <div class="member_profile_div">
                    <div class="member_profile_inner_area">

                        <div class="profile_area">

                            <div class="profile_row">
                                <div class="profile_title">{{label['member_profile_member_name_text']}}</div>
                                <div class="profile_data">{{member.name}}</div>
                            </div>
                            <div class="profile_row">
                                <div class="profile_title">{{label['member_profile_member_tel_text']}}</div>
                                <div class="profile_data">+{{member.countryCode}}-{{member.phone}}</div>
                            </div>
                            <div class="profile_row">
                                <div class="profile_title">{{label['member_profile_member_email_text']}}</div>
                                <div class="profile_data">{{member.email}}</div>
                            </div>


                        </div>

                    </div>
                </div>
                <!-- member info end -->

                <!-- member address start -->
                <div class="member_profile_title addAddress">{{label['member_profile_member_address_saved_text']}}</div>
                <div class="member_profile_div">
                    <div class="member_profile_inner_area">

                        <div class="profile_area">

                            <div class="address_row_title">{{label['member_profile_member_address_default_text']}}</div>

                            <div class="address_row"
                                v-for="(addObj, index) in memberAddress.filter(a => a.isDefault)"
                                :key="'d'+index"
                                >
                                <div class="address_row_div" :class="{isselect : addObj.isDefault}">

                                    <div class="address_text_area">
                                        <div class="address_text_div">
                                            <div class="addres_contact">
                                                <span v-if="addObj.address_tag != undefined && addObj.address_tag != ''">{{addObj.address_tag}}．</span>{{addObj.contact_info['name']}}．+{{addObj.contact_info['tel_countryCode']}}-{{addObj.contact_info['tel']}}
                                            </div>
                                            <div class="address_text">{{addObj.address['address_full_'+info.lang]}}</div>                                        
                                        </div>
                                        <div class="address_edit_div">
                                            <div class="address_edit_btn" @click="memberProfileAddressEditClick(addObj)">{{label['common_text_edit']}}</div>
                                        </div>

                                    </div>

                                </div>
                                <!-- address_row_div -->

                            </div>
                            <!-- address_row -->

                            <div class="address_row"
                                v-for="(addObj, index) in memberAddress.filter(a => !a.isDefault)"
                                :key="'a'+index"
                                >
                                <div class="address_row_div">

                                    <div class="address_text_area">
                                        <div class="address_text_div">
                                            <div class="addres_contact">
                                                <span v-if="addObj.address_tag != undefined && addObj.address_tag != ''">{{addObj.address_tag}}．</span>{{addObj.contact_info['name']}}．+{{addObj.contact_info['tel_countryCode']}}-{{addObj.contact_info['tel']}}
                                            </div>
                                            <div class="address_text">{{addObj.address['address_full_'+info.lang]}}</div>                                        
                                        </div>
                                        <div class="address_edit_div">
                                            <div class="address_edit_btn" @click="memberProfileAddressEditClick(addObj)">{{label['common_text_edit']}}</div>
                                        </div>

                                    </div>

                                </div>
                                <!-- address_row_div -->

                            </div>
                            <!-- address_row -->

                            <div class="address_new_row" v-if="cart.memberAddress.length < info.memberAddressSaveLimit">

                                <div class="address_new_row_div">
                                    <div class="new_address_btn_area" @click="memberProfileAddressEditClick()">
                                        <div class="new_address_btn_div"></div>
                                        <div class="new_address_text_div">{{label['add_address_text']}}</div>
                                    </div>
                                </div>
                                <!-- modify_address_new_address_div -->

                            </div>
                            <!-- modify_address_new_address_area end -->

                        </div>

                    </div>
                </div>
                <!-- member address end -->

            </div>
        </div>


        <!-- address_form start -->
        <transition name="slide-up">
            <div class="address_form_area" v-if="is_address_form" :style="{'height':$root.full_screen_height.height_fix}">

                <div class="modify_address_div">

                    <div class="modify_address_header_area">
                        <div class="modify_address_header_area_empty display_desktop"></div>
                        <div class="modify_address_back_btn display_responsive" @click="memberProfileAddressCloseClick()"></div>
                        <div class="modify_address_header_area_text display_responsive">{{modify_address_header_text}}</div>
                        <div class="modify_address_header_area_remove_icon display_responsive" v-if="is_address_edit" @click="memberProfileAddressRemove()"></div>
                        <div class="modify_address_close_btn display_desktop" @click="memberProfileAddressCloseClick()"></div>
                    </div>
                    <!-- modify_address_header_area end -->

                    <div class="modify_address_body_area">

                        <div class="modify_address_info_area display_desktop isflex">
                            <div class="modify_address_info_header">{{modify_address_header_text}}</div>
                            <div class="modify_address_info_remove_icon" v-if="is_address_edit" @click="memberProfileAddressRemove()"></div>
                        </div>
                        <!-- modify_address_info_area end -->

                        <div class="modify_address_form_area">
                            <div class="modify_address_form_div">

                                <div class="address_form_full_address_div" :key="address_form_isUpdate">{{modify_address.address['address_full_'+info.lang]}}</div>

                                <div class="address_form_div">

                                    <div class="map_address_area address_input_div">
                                        <div class="map_location_icon" @click="$root.SearchAddressPositionLL('member_profile_address_map_location_input','member_profile')"></div>
                                        <div class="map_location_input_div input_area" :class="{inSearch : $root.isSearchAddressFocus}">
                                            <input autocomplete="off" type="text" class="map_location_input" id="member_profile_address_map_location_input" value="" :placeholder="label['search_address_building_text']" @keyup="$root.SearchAddressText($event,'member_profile')" @focus="$root.SearchAddressFocus($event,'member_profile')" @blur="$root.SearchAddressBlur($event,'member_profile')" />
                                        </div>
                                        <div class="map_location_cancel_icon_div" v-if="$root.isSearchAddressFocus">
                                            <div class="map_location_cancel_icon" @click="$root.SearchAddressCancel()"></div>
                                        </div>
                                        <div class="map_location_cancel_icon_div search_icon" v-if="$root.isSearchAddressFocus">
                                            <div class="map_location_cancel_icon" @click="$root.SearchAddressText($event,'member_profile')"></div>
                                        </div>
                                    </div>

                                    <div class="flat_floor_area">
                                        <div class="block_div">
                                            <input autocomplete="off" type="text" class="address_form_input" id="modify_address_map_location_block_input" v-model="modify_address.address.block" maxlength="10" :placeholder="label['modify_address_block_text']" @blur="modifyAddressUpdateFullAddress()" />
                                        </div>
                                        <div class="floor_div">
                                            <input autocomplete="off" type="text" class="address_form_input" id="modify_address_map_location_floor_input" v-model="modify_address.address.floor" maxlength="10" :placeholder="label['modify_address_floor_text']" @blur="modifyAddressUpdateFullAddress()" />
                                        </div>
                                        <div class="flat_div">
                                            <input autocomplete="off" type="text" class="address_form_input" id="modify_address_map_location_flat_input" v-model="modify_address.address.flat" maxlength="10" :placeholder="label['modify_address_flat_text']" @blur="modifyAddressUpdateFullAddress()" />
                                        </div>
                                    </div>

                                    <div class="receiver_area">
                                        <div class="receiver_header_area">{{label['modify_address_header']}}</div>

                                        <div class="receiver_input_area">
                                            <div class="receiver_name_div">
                                                <input autocomplete="off" type="text" class="address_form_input" id="modify_address_map_location_contact_name_input" v-model="modify_address.contact_info.name" maxlength="50" :placeholder="label['modify_address_name_text']" @blur="modifyAddressUpdateKey()" />
                                            </div>
                                            <div class="receiver_tel_div">
                                                <select class="address_form_input select select_arrow_fix" id="modify_address_map_location_contact_tel_countryCode_input" v-model="modify_address.contact_info.tel_countryCode">
                                                    <option v-for="(c, index) in $root.countryCodeList" :value="c">
                                                        +{{c}}
                                                    </option>
                                                </select>
                                                <input autocomplete="off" type="text" class="address_form_input selectinput" id="modify_address_map_location_contact_tel_input" v-model="modify_address.contact_info.tel" maxlength="20" :placeholder="label['modify_address_tel1_text']" @blur="modifyAddressUpdateKey()" />
                                            </div>
                                            <!--<div class="receiver_subtel_div">
                                                <input autocomplete="off" type="text" class="address_form_input" id="modify_address_map_location_contact_tel2_input" v-model="modify_address.contact_info.tel2" maxlength="20" :placeholder="label['modify_address_tel2_text']" />
                                            </div>-->
                                        </div>

                                        <div class="receiver_input_area2">
                                            <div class="receiver_name_div ">
                                                <input autocomplete="off" type="text" class="address_form_input" id="modify_address_map_location_address_tag_input" v-model="modify_address.address_tag" maxlength="50" :placeholder="label['modify_address_tag_text']" />
                                            </div> 
                                        </div>

                                    </div>

                                    <div class="save_address_area">
                                        <div class="save_address_div" :class="{active : address_form_isDefault}" @click="memberProfileAddressIsDefaultClick()">
                                            <div class="save_addres_tick"></div>
                                            <div class="save_address_text">{{label['member_profile_member_address_set_default_text']}}</div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <!-- modify_address_form_area -->
                        
                    </div>

                    <div class="modify_address_confirm_area">
                        <div class="modify_address_confirm_btn" :class="{active : memberProfileAddressCheckCanSubmit(false)}" @click="memberProfileAddressEditUpdate()">{{label['modify_address_complete_address_text']}}</div>
                    </div>
                    <!-- modify_address_confirm_area end -->

                </div>
            </div>
        </transition>
        <!-- modify_address_area end -->


    </div>
</template>

<script>
    export default {
        data() {
            return {
                is_address_form: false,
                is_address_edit:false,
                address_form_isUpdate:0,
                modify_address_header_text: "",
                modify_address: null,
                address_form_isDefault:false,
            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            },
            cart() {
                return this.$root.cart;
            },
            member() {
                return this.$root.cart.member;
            },
            memberAddress() {
                return this.$root.cart.memberAddress;
            },
        },
        components: {},
        created() {

            this.info.loading = false;           
            this.$root.getCurrentPathName();

            if (this.member == null) {
                this.$root.page_after_login = this.info.currentPathName;
                this.$router.push("/guestlogin");
            }

            // get and renew member address list
            this.$root.GetMemberAddressList();
            //console.log("memberAddress", this.memberAddress);

            this.is_address_form = false;
        },
        methods: {
            getItemSubfix() {
                return this.$root.getItemSubfix();
            },   

            memberProfileAddressEditClick(addObj) {
                //console.log("addObj", addObj);
                
                var isOpenForm = false;
                if (addObj == undefined || addObj == null) {
                    if (this.cart.memberAddress.length + 1 > this.info.memberAddressSaveLimit) {
                        this.$root.alert("modify_address_alert_address_save_is_limit");
                    } else {
                        isOpenForm = true;
                        this.modify_address_header_text = this.label['member_profile_member_modify_address_header_text_new'];
                        this.is_address_edit = false;

                        // empty a modify_address
                        this.modify_address = { "address_id": "new_address", "address_type": "member", "address_tag": "" };
                        this.modify_address.address = JSON.parse(JSON.stringify(this.$root.info.order_temp_info.order_address_sample));
                        this.modify_address.contact_info = JSON.parse(JSON.stringify(this.$root.info.order_temp_info.order_contact_info_sample));
                        this.modify_address.contact_info.email = this.cart.member.email + "";
                        this.modify_address.isDefault = false;
                        this.modify_address.isSave = true;
                        this.address_form_isDefault = false;

                        console.log("this.modify_address.contact_info", this.modify_address.contact_info);
                        console.log("JSON.parse(JSON.stringify(this.$root.info.order_temp_info.order_contact_info_sample)", JSON.parse(JSON.stringify(this.$root.info.order_temp_info.order_contact_info_sample)));

                    }
                } else {
                    isOpenForm = true;                    
                    this.modify_address_header_text = this.label['member_profile_member_modify_address_header_text_edit'];
                    this.is_address_edit = true;

                    this.modify_address = addObj;
                    this.address_form_isDefault = addObj.isDefault;                    
                }

                if (isOpenForm) {
                    this.$root.setBodyOverflow(true);
                    this.$root.modify_address = this.modify_address;
                    this.$root.modify_address_isSave = true;
                    this.is_address_form = true;
                    this.memberProfileAddressEditFillData();
                }
            },
            memberProfileAddressEditFillData() {
                var modify_address_map_location_input = this.$el.querySelector("#member_profile_address_map_location_input");

                //console.log("modify_address_map_location_input",modify_address_map_location_input);
                if (modify_address_map_location_input != null) {
                    modify_address_map_location_input.value = this.modify_address.address['address_'+this.info.lang];
                    var modify_address_location = this.modify_address.address['location'].split(',');
                    $(modify_address_map_location_input).data("oldValue", {"address_zh":this.modify_address.address['address_zh'],"address_en":this.modify_address.address['address_en'],"address_sc":this.modify_address.address['address_sc'],"latitude":modify_address_location[0],"longitude":modify_address_location[1]});
                } else {
                    setTimeout(this.memberProfileAddressEditFillData,100);
                }
            },
            memberProfileAddressCloseClick() {
                this.$root.SearchAddressCancel();
                this.is_address_form = false;
                this.is_address_edit = false;
                this.modify_address = null;
                this.$root.modify_address = null;
                this.$root.modify_address_isSave = false;
                this.address_form_isDefault = false;
                this.$root.setBodyOverflow(false);
            },
            memberProfileAddressCheckCanSubmit(isAlert) {
                if (this.modify_address != null && this.modify_address.address.address_en != '' && !(this.modify_address.address.block == '' && this.modify_address.address.flat == '' && this.modify_address.address.floor == '') && this.modify_address.contact_info.name != '' && this.modify_address.contact_info.tel != '') {
                    if (this.$root.CheckPhoneFormat(this.modify_address.contact_info.tel)) {
                        return true;
                    }
                    else {
                        if (isAlert)
                            this.$root.alert("tel.invalid");

                        return false;
                    }
                }
                else {
                    if (isAlert)
                        this.$root.alert("modify_address_alert_please_fill_correct_address_and_contact_info");

                    return false;
                }
            },
            memberProfileAddressEditUpdate() {
                this.$root.SearchAddressCancel();
                if (this.memberProfileAddressCheckCanSubmit(true)) {
                    this.info.loading = true;

                    // check isDefault click
                    if (this.address_form_isDefault) {
                        $.each(this.cart.memberAddress, (i, a) => {
                            a.isDefault = false;
                        });
                        this.modify_address.isDefault = this.address_form_isDefault;
                    }                    

                    // check isNew address
                    var isNew = (this.modify_address["address_id"] == "new_address");
                    if (isNew) {
                        this.cart.memberAddress.push(JSON.parse(JSON.stringify(this.modify_address)));
                    }

                    // check contains isDefault address
                    if (this.cart.memberAddress.length > 0 && this.cart.memberAddress.filter(a => a.isDefault).length <= 0) {
                        this.cart.memberAddress[0].isDefault = true;
                    }

                    // reset id
                    $.each(this.cart.memberAddress, (i, a) => {
                        a["address_id"] = "madd" + (i + 1);
                    });

                    // update member address
                    if (this.$root.UpdateSaveMemberAddressList(this.cart.memberAddress)) {

                        // update member address list
                        this.$root.GetMemberAddressList();

                        // reset data
                        this.info.loading = false;
                        this.is_address_form = false;
                        this.is_address_edit = false;
                        this.modify_address = null;
                        this.$root.modify_address = null;
                        this.$root.modify_address_isSave = false;
                        this.address_form_isDefault = false;
                        this.$root.setBodyOverflow(false);

                    }
                    // else if update member address fail
                    else {
                        this.info.loading = false;
                    }
                }
            },
            memberProfileAddressIsDefaultClick() {
                if (this.address_form_isDefault) {
                    this.address_form_isDefault = false;
                } else {
                    this.address_form_isDefault = true;
                }
            },
            memberProfileAddressRemove() {
                var app = this;
                this.$root.setConfirmMsg(this.label["member_profile_member_confirm_remove_address_text"].replace("#address#", app.modify_address.address["address_full_" + app.info.lang]), function () { app.memberProfileAddressRemoveConfirm(); }, undefined);
            },
            memberProfileAddressRemoveConfirm() {
                this.$root.SearchAddressCancel();
                this.info.loading = true;
                var new_address_list = [];

                // get new address list
                $.each(this.cart.memberAddress, (i, a) => {
                    if (a["address_id"] != this.modify_address["address_id"]) {
                        new_address_list.push(a);
                    }                    
                });

                // check contains isDefault address
                if (new_address_list.length > 0 && new_address_list.filter(a => a.isDefault).length <= 0) {

                    new_address_list[0].isDefault = true;
                }

                // reset id
                $.each(new_address_list, (i, a) => {
                    a["address_id"] = "madd" + (i + 1);
                });

                // update member address
                if (this.$root.UpdateSaveMemberAddressList(new_address_list)) {

                    // update member address list
                    this.$root.GetMemberAddressList();

                    // reset data
                    this.info.loading = false;
                    this.is_address_form = false;
                    this.is_address_edit = false;
                    this.modify_address = null;
                    this.$root.modify_address = null;
                    this.$root.modify_address_isSave = false;
                    this.address_form_isDefault = false;
                    this.$root.setBodyOverflow(false);
                }
                // else if update member address fail
                else {
                    this.info.loading = false;
                }
            },
            modifyAddressUpdateFullAddress() {
                var zh_str = this.modify_address.address.address_zh + ((this.modify_address.address.block != '' && this.modify_address.address.block != undefined) ? " " + this.modify_address.address.block + "" + allLabel['zh']['modify_address_address_fill_block_text'] + "" : '') + (this.modify_address.address.floor != '' ? " " + this.modify_address.address.floor + "" + allLabel['zh']['modify_address_address_fill_floor_text'] + "" : '') + (this.modify_address.address.flat != '' ? " " + this.modify_address.address.flat + "" + allLabel['zh']['modify_address_address_fill_flat_text'] + "" : '');
                var en_str = (this.modify_address.address.flat != '' ? allLabel['en']['modify_address_address_fill_flat_text'] + " " + this.modify_address.address.flat + ", " : '') + (this.modify_address.address.floor != '' ? allLabel['en']['modify_address_address_fill_floor_text'] + " " + this.modify_address.address.floor + ", " : '') + ((this.modify_address.address.block != '' && this.modify_address.address.block != undefined) ? this.modify_address.address.block + " " + allLabel['en']['modify_address_address_fill_block_text'] + ", " : '') + this.modify_address.address.address_en;
                this.modify_address.address['address_full_zh'] = zh_str;
                this.modify_address.address['address_full_en'] = en_str;
                this.modify_address.address['address_full_sc'] = zh_str;
                this.modify_address.isDefault = this.address_form_isDefault;
                this.modifyAddressUpdateKey();
            },
            modifyAddressUpdateKey() {
                this.address_form_isUpdate++;
            },


        },
    };
</script>
